import { Component, OnInit, Input } from '@angular/core';
import { AppComponent} from '../../app.component';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { AlertService } from '../../alertpopup/_alert';
export class UserData {
  NDList: NotificationUserData [];
  UserData: UserMaster[];
}
export class UserMaster {
  ID: any;
  UserName: string;
  Email: string;
  Mobile: any;
}
export class InsertNotifyData {
  NDList: [];
  recEnable: string;
}
export class NotificationUserData {
  FeatureID:any;
  FeatureDs : string;
  ModuleID:any;
  ModuleDs : string;
  ID: any;
  UserID:any;
  UserName: string;
  Email: string;
  Mobile: any;
  SelectedEmployee = [];
  EmailEmployee = [];
  SMSEmployee = [];
   NonUser : string;
  recEnable: any;
  IsClient: any;
}

@Component({
    selector: 'app-notification-entry',
    templateUrl: './notification-entry.component.html',
    styleUrls: ['./notification-entry.component.css'],
    standalone: false
})
export class NotificationEntryComponent implements OnInit {
  @Input() NotificationData: NotificationUserData;
  url: string;
  pageurl:string;
  id: string;
  userDataId : string;
  UserMasterDetail: any;
  NotificationEntry: FormGroup;
  ModuleID : string;
  options = {
    autoClose: true,
    keepAfterRouteChange: false
};
 
  constructor(private router: Router, private http: HttpClient, private formBuilder: FormBuilder, protected alertService: AlertService) { this.url = AppComponent.baseURL; }

  ngOnInit() {
    this.NotificationEntry = this.formBuilder.group({
    });
    const formGroup = {};
    formGroup['Employee'] = new FormControl("");
    formGroup['EmailManager'] = new FormControl("");
    formGroup['SMSManager'] = new FormControl("");
    formGroup['ID'] = new FormControl("");
    formGroup['UserDataID'] = new FormControl("");
    formGroup['NonUser'] = new FormControl("");
    this.NotificationEntry = new FormGroup(formGroup);

    this.NotificationData = new NotificationUserData();
    this.pageurl = this.router.url;
    let pagehead = this.pageurl.split('/');
    this.userDataId = pagehead[2];
    this.id = pagehead[3];
    this.ModuleID = pagehead[4];
    this.LoadData();
  }

  LoadData() {
    this.http.get(this.url + 'AlertNotificationDetail/LoadNotification?ID=' + this.id + "&UserDataID=" + this.userDataId+"&ModuleID="+this.ModuleID)
    .subscribe( (data) => {
        if (data == null || data.toString() == "[]") {

        } else {
          let userData: UserData = JSON.parse(data.toString());
          let notificationUserData: NotificationUserData [] = userData.NDList;

          if(userData.NDList.length > 0)
          {
            this.NotificationData = userData.NDList[0];
          }
          console.log(this.NotificationData);
          let userMaster: UserMaster[] = userData.UserData;
          this.UserMasterDetail = userData.UserData;

          // Patch Values
          if(this.NotificationData.ID > 0)
          {
            (this.NotificationEntry.get(String('Employee')) as FormControl).patchValue(this.NotificationData.UserID);

            if(this.NotificationData.EmailEmployee.toString().split(',').length > 0)
            {
              this.NotificationData.EmailEmployee = this.NotificationData.EmailEmployee.toString().split(',').map(Number);
              (this.NotificationEntry.get(String('EmailManager')) as FormControl).patchValue(this.NotificationData.EmailEmployee);
            }
            if(this.NotificationData.SMSEmployee.toString().split(',').length > 0)
            {
              this.NotificationData.SMSEmployee = this.NotificationData.SMSEmployee.toString().split(',').map(Number);
              (this.NotificationEntry.get(String('SMSManager')) as FormControl).patchValue(this.NotificationData.SMSEmployee);
            }
          }
        }
      },
      (error) => {
       }
    );
  }

  onNotificationSubmit(Data){
    if(Data.Employee < 1){
      this.alertService.warn('Please select employee', this.options);
      return;
    }
  
    this.http.post(this.url + 'AlertNotificationDetail/UpdateNotification', Data) .subscribe( (data) => {
      if (data == null) {
        this.alertService.showError('An Error Occurred');
      } else {
        this.alertService.showSuccess(data.toString());
      }
     }
   );
  }

}
